'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WSR]');

var winresServiceReq = function () {
    function winresServiceReq($scope) {
        _classCallCheck(this, winresServiceReq);
    }

    _createClass(winresServiceReq, [{
        key: '$onInit',
        value: function $onInit() {}
    }, {
        key: 'isSingle',
        value: function isSingle() {
            return this.min == 1 && this.max == 1;
        }
    }, {
        key: 'isValid',
        value: function isValid() {
            return _.isEmpty(this.errors);
        }
    }, {
        key: 'minClasses',
        value: function minClasses() {
            return {
                'text-danger': this.highlightErrors && this.errors['min']
            };
        }
    }, {
        key: 'maxClasses',
        value: function maxClasses() {
            return {
                'text-danger': this.highlightErrors && this.errors['max']
            };
        }
    }]);

    return winresServiceReq;
}();

winresServiceReq.$inject = [];

_module3.default.component('winresServiceReq', {
    template: require('./winresServiceReq.html'),
    controller: winresServiceReq,
    bindings: {
        // Minimum amount required.
        min: '<',

        // Maximum amount required.
        max: '<',

        // Angular $error object.
        errors: '<',

        // True if errors should be highlighted. Generally set after
        // the user has interacted with the controller (so they don't
        // get red warnings before they've even had a chance to do
        // anything).
        highlightErrors: '<',

        // Total amount selected. Not required.
        totalAmount: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceReq/winresServiceReq.js
// module id = 453
// module chunks = 2